import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/faqs";
import SectionTitle from "@/components/base/SectionTitle";

export default function FaqPreview() {
  const [open, setOpen] = useState<number | null>(0);
  const shown = faqs.slice(0, 5);
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="mx-auto max-w-4xl px-4 md:px-10">
        <SectionTitle
          eyebrow="FAQ"
          title="よくあるご質問"
          description="ご相談前によくいただく質問をまとめました。ここに載っていないことも、遠慮なくお尋ねください。"
        />

        <div className="space-y-3">
          {shown.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={f.q}
                className="bg-background-50 rounded-lg border border-background-200 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : idx)}
                  className="w-full flex items-center justify-between gap-4 px-5 md:px-7 py-5 text-left cursor-pointer whitespace-nowrap"
                >
                  <span className="flex items-start gap-3 flex-1 whitespace-normal">
                    <span className="font-heading text-accent-600 mt-0.5">Q.</span>
                    <span className="text-sm md:text-base font-medium text-foreground-950">
                      {f.q}
                    </span>
                  </span>
                  <span
                    className={`w-8 h-8 flex items-center justify-center rounded-full border border-background-300 text-foreground-700 transition-transform ${
                      isOpen ? "rotate-45 bg-primary-500 border-primary-500 text-background-50" : ""
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 md:px-7 pb-6 pt-0 border-t border-background-200">
                    <div className="flex items-start gap-3 pt-4">
                      <span className="font-heading text-primary-600">A.</span>
                      <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                        {f.a}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/faq"
            className="inline-flex items-center gap-2 text-sm text-primary-700 hover:text-primary-800 cursor-pointer"
          >
            すべての質問を見る
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}